<template>
    <div id="acteurs">
        <HeaderGeneral banner="pers-les-acteurs-du-projet.jpg"/>
        
        <img src="../../assets/airdutemps.png" class="airdutemps"/>
        <img src="../../assets/paris-75.png" class="paris-75"/>

        <div id="nav" class="li-lvl2">
            <Nav :links="links" :visible="visible" title="Les acteurs du projet" v-on:launch-gallery="launchGallery"/>
        </div>
        <!-- Hidden video div -->
        <div style="display:none;" id="video1">
          <video class="lg-video-object lg-html5 video-js vjs-default-skin" controls preload="none">
            <source src="../../assets/COGEDIM_ITW_ARCHITECTES_VDEF.mp4" type="video/mp4">
            Your browser does not support HTML5 video.
          </video>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .airdutemps {
      position: absolute;
      z-index: 2;
      width: 168px; 
      height: auto;
      right: 121px;
      bottom: 387px;
      @media (min-width: 992px) {
        right: 118px;
        bottom: 261px;
      }
    }
    .paris-75 {
      position: absolute; 
      z-index: 2;
      width: 81px;
      height: auto;
      right: 30px;
      bottom: 398px;
      @media (min-width: 992px) {
        right: 27px;
        bottom: 272px;
      }
    }
</style>

<script>
// @ is an alias to /src
import HeaderGeneral from '@/components/Header.vue';
import Nav from '@/components/Nav.vue';
import 'lightgallery.js';
import 'lg-thumbnail.js';
import 'lg-video.js';
import 'lg-hash.js';
import 'lightgallery.js/dist/css/lightgallery.css';

export default {
    name: 'Acteurs',
    components: {
        HeaderGeneral,
        Nav,
    }, 
    data: () => {
    
        return {
            links: [
                {
                    title: "Interview",
                    path: 'none',
                    icon: 'interview.svg'
                },
                {
                    title: "Le mot des architectes",
                    path: 'Architectes',
                    icon: 'les-mots.svg'
                },
            ],
            galleryItems: {
              'Interview': [
                {
                  html: '#video1',
                  thumb: 'https://sachinchoolur.github.io/lightGallery/static/img/videos/y-video1-cover.jpg',
                }
              ]
            },
            
            visible: true,
        };
    },
    methods: {
      launchGallery: function(name) {

        var lg = document.querySelector('.dynamic');
        
        // Destroy gallery on close
        lg.addEventListener('onCloseAfter', function(e){
          if(window.lgData[lg.getAttribute('lg-uid')] != undefined) {
            window.lgData[lg.getAttribute('lg-uid')].destroy(true);
          }
        }, false);
        
        // Init Gallery
        lightGallery(lg, 
          {
            dynamic: true,
            dynamicEl: this.galleryItems[name],
            /*hash: true,
            galleryIdl: name.length*/
          }
        );
        
      }
    },
    mounted() {
    },
};

</script>